const PopupImage = ({trigger, setTrigger, children}) => {
  return (trigger) ? (
    <div className="popup">
      <button className="close-btn" onClick={() => setTrigger(false)}>Κλείσιμο</button>
      { children }
    </div>
  ) : "";
}
 
export default PopupImage;